export type {
  DeeplinkNavigationServiceRequest,
  DeeplinkNavigationServiceResponse,
} from './deeplink-navigation.dto';
export { deeplinkNavigationService } from './deeplink-navigation.service';
